
import BaseModel from "./BaseModel";

class Image extends BaseModel {
  id: number;
  uuid: string;
  name: string;
  alt: string;
  width: number;
  height: number;
  aspectRatio: number;
  mimeType: string;
  thumbHash?: string;
  contentHash: string;
  sizeBytes: number;
  version: number;

  static __dates = [];
  constructor(data) {
    super(data, Image.__dates);
    this.id = data.id;
    this.uuid = data.uuid;
    this.name = data.name;
    this.alt = data.alt;
    this.width = data.width;
    this.height = data.height;
    this.aspectRatio = data.aspectRatio;
    this.mimeType = data.mimeType;
    this.thumbHash = data.thumbHash;
    this.contentHash = data.contentHash;
    this.sizeBytes = data.sizeBytes;
    this.version = data.version;
  }

  /// Get URL to load the actual image
  static getSrcUrl(image: Image): string {
    // Content hash is added for cache bursting.
    let cache_str = image.version > 0 ? `#${image.version}` : '';
    return `${process.env.REACT_APP_API_URL}/image/get/${image.id}${cache_str}`;
  }
}

export class ImageDTO {
  id: number;
  name: string;
  alt: string;
  width: number;
  height: number;
  mimeType: string;
  version: number;

  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.alt = data.alt;
    this.width = data.width;
    this.height = data.height;
    this.mimeType = data.mimeType;
    this.version = data.version;
  }

  /// Get URL to load the actual image
  static getSrcUrl(image: ImageDTO): string {
    // Content hash is added for cache bursting.
    let cache_str = image.version > 0 ? `#${image.version}` : '';
    return `${process.env.REACT_APP_API_URL}/image/get/${image.id}${cache_str}`;
  }
}

export class CreateImageRequest extends BaseModel {
  name: string;
  alt: object;
  file: File;

  static __dates = [];
  constructor(data) {
    super(data, Image.__dates);
    this.name = data.name;
    this.alt = data.alt;
    this.file = data.file;
  }
}

export class UpdateImageRequest extends BaseModel {
  name: string;
  alt: object;
  file?: File;

  static __dates = [];
  constructor(data) {
    super(data, Image.__dates);
    this.name = data.name;
    this.alt = data.alt;
    this.file = data.file;
  }
}

export default Image;
